import * as React from 'react';
import {
  CarouselBreakpoints,
  MentorsItem as TMentorsItem,
} from '~/common/types/types';
import { Carousel } from '~/components/common/common';
import { MentorsItem } from '../components';
import * as styles from './mentors-list.module.scss';

const BREAKPOINTS: CarouselBreakpoints = {
  0: {
    slidesPerView: 'auto',
    spaceBetween: '15',
    wrapperClassName: styles.wrapper,
  },
  576: {
    slidesPerView: 2,
    spaceBetween: '20',
    wrapperClassName: styles.wrapper,
  },
  1024: {
    slidesPerView: 3,
    spaceBetween: '20',
    wrapperClassName: styles.wrapper,
  },
  1280: {
    slidesPerView: 3,
    spaceBetween: '30',
    wrapperClassName: styles.wrapper,
  },
};

type Props = {
  items: TMentorsItem[];
};

const MentorsList: React.FC<Props> = ({ items }) => (
  <Carousel breakpoints={BREAKPOINTS} hasNavigation className={styles.carousel}>
    {items.map((it) => (
      <MentorsItem item={it} key={it.name} />
    ))}
  </Carousel>
);

export { MentorsList };
